'use strict';

const $ = require('jquery');

let gallery = {
  resizeTimer: null,
  loadPhotoset: function() {
    // Store original image dimensions
    $('.photoset-item img').each(function () {
      $(this)
        .data('org-width', $(this)[0].naturalWidth)
        .data('org-height', $(this)[0].naturalHeight)
        .hide()
        .parent('a')
        .css({
          'background-image': 'url(' + $(this).attr('src') + ')'
        });
    });
  },
  initPhotoset: function() {
    $('.photoset img').hide();

    // Detect viewport size
    if ($(window).width() > 768) {
      // Set photoset image size
      $('.photoset-row').each(function () {
        var $pi = $(this).find('.photoset-item'),
          cWidth = $(this).parent('.photoset').width();

        // Generate array containing all image aspect ratios
        var ratios = $pi.map(function () {
          return $(this).find('img').data('org-width') / $(this).find('img').data('org-height');
        }).get();

        // Get sum of widths
        var sumRatios = 0,
          sumMargins = 0,
          minRatio = Math.min.apply(Math, ratios);
        for (var i = 0; i < $pi.length; i++) {
          sumRatios += ratios[i] / minRatio;
        }

        $pi.each(function () {
          sumMargins += parseInt($(this).css('margin-left')) + parseInt($(this).css('margin-right'));
        });

        // Calculate dimensions
        $pi.each(function (i) {
          var minWidth = (cWidth - sumMargins) / sumRatios;
          $(this).find('a')
            .height(Math.floor(minWidth / minRatio))
            .width((minWidth / minRatio) * ratios[i]);
          // with round > .width(Math.floor(minWidth / minRatio) * ratios[i]);
        });
      });
    } else if ($(window).width() <= 768 && $(window).width() > 480) {
      $('.photoset-row').each(function () {
        var $pi = $(this).find('.photoset-item'),
          cWidth = $(this).parent('.photoset').width(),
          sumMargins = 0;

        $pi.each(function () {
          sumMargins += parseInt($(this).css('margin-left')) + parseInt($(this).css('margin-right'));
        });

        $pi.each(function () {
          $(this).find('a')
            .width((cWidth - sumMargins) / $pi.length)
            .height((cWidth - sumMargins) / $pi.length);
        });
      });
    } else {
      $('.photoset-item').each(function () {
        $(this).find('img').show();
        $(this).find('a').css({
          width: '100%',
          height: 'auto'
        });
      });
    }
  },
  initGalleries: function(){
    //let galleryComponents = $('.section-gallery');
    let galleryComponents = $('.image-gallery-component');

    if(galleryComponents.length){
      galleryComponents.each(function () {
        var gallery = $(this),
          id = $(this).attr('id'),
          variableName = id + '_gallery_items',
          items = window[variableName] ? window[variableName] : null;

        if (items && items.length) {
          $(gallery)
            .find('figure a img[data-gallery-image]')
            .each(function (index) {
              $(this)
                .parents('a')
                .toggleClass('open-gallery', true)
                .off('click')
                .on('click', function (e) {
                  e.preventDefault();
                  $.magnificPopup.open({
                    items: items,
                    gallery: {
                      enabled: true
                    },
                    image: {
                      // options for image content type
                      titleSrc: function (item) {
                        var imgItem = $(item).find('img').attr('src');
                        return imgItem;
                      }
                    }
                  }, index);
                });
            });
          $(gallery)
            .find('.view-more-images')
            .each(function () {
              $(this)
                .click(function (e) {
                  e.preventDefault();
                  var target = $(this).data('target-index');
                  if (typeof target !== 'undefined' && target) {
                    $.magnificPopup.open({
                      items: items,
                      gallery: {
                        enabled: true
                      },
                      image: {
                        // options for image content type
                        titleSrc: function (item) {
                          var imgItem = $(item).find('img').attr('src');
                          return imgItem;
                        }
                      }
                    }, target);
                  }
                });
            });

        }

        if ($(gallery).find('.swiper-container').length) {
          var swiper = new Swiper('.swiper-container', { // eslint-disable-line
            loop: true
          });
        }

      }); // each gallery
    }
  },
  init: function(){
    // Init only on version 2018
    if(!$('html').hasClass('v-2018')){
      return;
    }

    let self = this;
    this.initGalleries();
    this.loadPhotoset();
    this.initPhotoset();

    $(window).on('resize', function(){
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function(){
        self.initPhotoset();
      }, 500);
    });

  }
}; // gallery

export default gallery;
